document.addEventListener("turbo:load", function () {
    $(function () {
        $('.action--role').removeClass('action--role').change(function () {
            $('.action--item').hide();
            $('.role-'+$(this).val()).show();

        }).change();

    });
})
